import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { CatalogueService } from '@app/services/catalogue';
import { ActiveRange, ProductType } from '@app/services/catalogue/models';
import { DialogService } from '@app/services/dialog';
import { NavigationService } from '@app/services/navigation';
import { ViewMode, NavigationRoute } from '@app/services/navigation/models';

import { MegaMenuCategories } from '@app/shared/components/mega-menu/models';
import { StringHelper } from '@app/utilities/helpers';

@Component({
    selector: 'page-basket-builder',
    templateUrl: './basket-builder.page.html',
    styleUrls: ['./basket-builder.page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BasketBuilderPage implements OnInit, OnDestroy {
    public ProductType = ProductType;
    public MegaMenuCategories = MegaMenuCategories;
    public megaMenuCategory: MegaMenuCategories = null;

    public activeRange: ActiveRange;

    public page: string;
    public category: string;
    public subCategory: string;
    public details: string;
    public code: string;
    public filteredItems: any;

    private openMegaMenuOn: MegaMenuCategories;

    private routeSubscription: Subscription;

    constructor(
        private catalogueService: CatalogueService,
        private dialogService: DialogService,
        private navigationService: NavigationService
    ) {
        this.navigationService.setViewMode(ViewMode.BASKET_BUILDER);
    }

    ngOnInit() {
        this.routeSubscription = this.navigationService.route.subscribe(
            (route: NavigationRoute) => {
                this.category = route.params.category;
                this.subCategory = route.params.subCategory;
                this.details = route.params.details;
                this.code = route.params.code;

                let page = null;
                let setActiveRange = false;
                let url = route.url.replace('/basket-builder', '');

                if (route.segments.indexOf('kitchen-units') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = true;
                    page = 'kitchen-units';
                } else if (route.segments.indexOf('kitchen-doors') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = true;
                    page = 'kitchen-doors';
                } else if (route.segments.indexOf('appliances') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'appliances';
                } else if (route.segments.indexOf('sinks-and-taps') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'sinks-and-taps';
                } else if (route.segments.indexOf('handles') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'handles';
                } else if (route.segments.indexOf('accessories') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'accessories';
                } else if (route.segments.indexOf('laminate-worktops') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'laminate-worktops';
                } else if (route.segments.indexOf('wood-worktops') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'wood-worktops';
                } else if (route.segments.indexOf('solid-surfaces') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'solid-surfaces';
                } else if (route.segments.indexOf('samples') !== -1) {
                    this.megaMenuCategory = null;
                    setActiveRange = false;
                    page = 'samples';
                } else {
                    this.page = null;

                    if (this.openMegaMenuOn) {
                        this.megaMenuCategory = this.openMegaMenuOn;
                        this.openMegaMenuOn = null;
                    } else {
                        this.megaMenuCategory = MegaMenuCategories.UNITS;
                    }
                }

                if (setActiveRange) {
                    this.setActiveRange()
                        .then(() => {
                            this.page = page;

                            if (page === 'kitchen-doors') {
                                const style = StringHelper.kebabCase(`${this.activeRange.range.name} ${this.activeRange.rangeColour}`);
                                url += `/${style}/doors-only-ordering`;
                            }

                            this.navigationService.navigate([url]);
                        })
                        .catch((error) => this.dialogService.error(this.constructor.name, error))
                } else {
                    if (page) {
                        this.page = page;
                        this.navigationService.navigate([url]);
                    }
                }
            }
        );
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
            this.routeSubscription = null;
        }
    }

    public openMegaMenu(megaMenuCategory: MegaMenuCategories) {
        if (megaMenuCategory === MegaMenuCategories.DOORS) {
            this.navigationService.navigate(['basket-builder', 'kitchen-doors']);
        } else if (this.page) {
            this.openMegaMenuOn = megaMenuCategory;
            this.navigationService.navigate(['/basket-builder']);
        } else {
            this.megaMenuCategory = megaMenuCategory;
        }
    }

    public setActiveRange(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.catalogueService.openRangeSelector(false, true)
                .then((activeRange) => {
                    this.activeRange = activeRange;

                    this.catalogueService.activeRange = activeRange;
                    this.catalogueService.activeRange$.next(activeRange);
                    resolve();
                })
                .catch((error) => reject(error));
        });
    }
}
